export default __webpack_public_path__ + "static/media/Petronela_Sandulache_AHV_In_Moms_We_Trust.bc198bea.jpg";